import React, { Component } from "react";
import { auth } from "../../utils/auth";
import Form from "./Form";
import { apiUrl } from "../../utils/apiUrl";
import { withRequest } from "../../utils/request";
import Loader from "../general/Loader";

class Create extends Component {
    state = {
        errors: {},
        tiposEmpleados: [],
        saving: false,
    };
    componentDidMount() {
        this.getTable("tipos", "tiposEmpleados");
    }
    getTable = async (url, name = null) => {
        const request = await this.props.request(url);
        const table = name ? name : url;

        if (request.data) {
            this.setState({
                [table]: request.data,
            });
            this.setState({
                loading: false,
            });
        }
    };
    createNomina = async (event) => {
        event.preventDefault();

        this.setState({ saving: true });

        const token = auth.getToken();
        const data = new FormData(event.target);

        const res = await fetch(apiUrl("nominas"), {
            method: "post",
            body: data,
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        const response = await res.json();

        if (response.success) {
            this.props.getNominas();
            this.props.toggle();
            this.setState({ saving: false });
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message, saving: false });
        }
    };
    render() {
        const { errors, saving, tiposEmpleados } = this.state;
        const { toggle, nomina } = this.props;
        return (
            <form method='post' onSubmit={this.createNomina}>
                <div className='popup__header'>Generar Nómina</div>
                <div className='popup__body'>
                    <Form
                        nomina={nomina}
                        tiposEmpleados={tiposEmpleados}
                        errors={errors}
                    />
                </div>
                <div className='popup__footer'>
                    <button
                        type='button'
                        onClick={toggle}
                        className='btn btn-plain'>
                        Cancelar
                    </button>
                    {saving ? (
                        <Loader type='small' />
                    ) : (
                        <button type='submit' className='btn btn-primary'>
                            Crear
                        </button>
                    )}
                </div>
            </form>
        );
    }
}

export default withRequest(Create);
